export enum Meaning {
    PLUS = '+',
    MINUS = '-',
}

export type Choice = string;
